import Masks from "../services/Masks";
import CFM from "../services/Cfm";

export default {
    props: [
        'lang',
        'initialProfile',
        'initialProfession',
        'initialSpecialty',
        'initialInterests',
        'profiles',
        'professions',
        'specialties',
        'interests',
        'locale',
        'currentSiteName',
        'ufs',
        'old'
    ],

    data: () => { return {
        agreedToTerms: false,
        profile: null,
        profession: null,
        specialty: null,
        selectedInterests: [],
        masks: Masks,
        crmLoading: false,
        formValidated: false,
        crmIsInvalid: null,
        crmResponseMessage: '',
        fields: {
            'crm': null,
            'gender': null,
            'name': null,
            'lastname': null,
            'document_identity': null,

            'document_professional': null,
            'document_uf': null,

            'email': null,
            'email_confirmation': null,
            'phone': {
                'value': '',
                'mask': ''
            },
        }
    }},

    beforeMount() {

        if (this.initialProfile !== undefined) {
            this.profile = this.initialProfile;
        }

        if (this.initialProfession !== undefined) {
            this.profession = this.professions[this.profile].find((p) => p.id === parseInt(this.initialProfession, 10));
        }

        if (this.initialSpecialty !== undefined) {
            this.specialty = this.specialties[this.profession.id].find((s) => s.id === parseInt(this.initialSpecialty, 10));
        }

        if (this.initialInterests !== undefined) {
            this.selectedInterests = this.initialInterests;
        }

        if (this.old.profile_slug !== undefined) {
            this.profile = this.old.profile_slug;
        }

        if (this.old.profession_id !== undefined && this.old.profile_slug !== undefined) {

            let professionFound = null;
            Object.values(this.professions[this.old.profile_slug]).forEach((profession, index) => {
                if (profession.id === parseInt(this.old.profession_id)) {
                    professionFound = profession;
                }
            })
            this.profession = professionFound;

        }

        if (this.old.specialty_id !== undefined && this.old.profession_id !== undefined) {

            let specialityFound = null;
            Object.values(this.specialties[this.old.profession_id]).forEach((speciality, index) => {
                if (speciality.id === parseInt(this.old.specialty_id)) {
                    specialityFound = speciality;
                }
            })
            this.specialty = specialityFound;

        }

        if (this.old.name !== undefined) {
            this.fields.name = this.old.name;
        }


        if (this.old.lastname !== undefined) {
            this.fields.lastname = this.old.lastname;
        }

        if (this.old.document_identity !== undefined) {
            this.fields.document_identity = this.old.document_identity;
        }


        if (this.old.email !== undefined) {
            this.fields.email = this.old.email;
        }

        if (this.old.email_confirmation !== undefined) {
            this.fields.email_confirmation = this.old.email_confirmation;
        }

        if (this.old.document_professional !== undefined) {
            this.fields.document_professional = this.old.document_professional;
        }

        if (this.old.document_uf !== undefined) {
            this.fields.document_uf = this.old.document_uf;
        }

        if (this.old.crm_validated !== undefined) {
            this.crmIsInvalid = false;
        }

        if (this.old.phone !== undefined) {
            this.fields.phone.value = this.old.phone;
        }

        if (this.old.gender !== undefined) {
            this.fields.gender = this.old.gender;
        }

        if (this.old.agreed_to_terms !== undefined) {
            this.agreedToTerms = true;
        }

        if (this.old.interests !== undefined) {
            this.selectedInterests = this.old.interests;
        }

        this.$forceUpdate();

    },

    mounted: function() {
        this.fields['phone']['mask'] = this.masks.CellphoneWithDDD;
        window.errorMessages = JSON.parse(this.lang);
        this.customErrorMessages();
    },

    methods: {
        showHidePassword: function(event) {
            let passwordField = document.getElementById('fld-register-password');
            let btnIcon = document.getElementById('fld-register-password-icon');
            let activeType = passwordField.getAttribute('type');

            if(activeType === 'password') {
                passwordField.setAttribute('type', 'text');
                btnIcon.setAttribute('class', 'fa fa-eye');
            }else{
                passwordField.setAttribute('type', 'password');
                btnIcon.setAttribute('class', 'fa fa-eye-slash');
            }
        },
        customErrorMessages: function (event) {

            //Password Confirmed Validation
            let passwordField = document.getElementById('fld-register-password');
            let passwordConfirmField = document.getElementById('fld-register-confirm_password');

            // passwordConfirmField.addEventListener("input", function (event) {
            //     if (passwordField.value !== passwordConfirmField.value) {
            //         console.log('field=', passwordField.value, 'confirm=', passwordConfirmField.value, 'fields:', passwordField, passwordConfirmField);
            //         passwordConfirmField.setCustomValidity(window.errorMessages.repeatPassword);
            //     } else {
            //         passwordConfirmField.setCustomValidity("");
            //     }
            // });

            //Email Confirmed Validation
            let emailField = document.getElementById('fld-register-email');
            let emailConfirmField = document.getElementById('fld-register-confirm_email');

            if (!emailConfirmField) {
                console.warn("Missing email confirm field");
                return;
            }

            emailConfirmField.addEventListener("input", function (event) {
                if (emailField.value !== emailConfirmField.value) {
                    emailConfirmField.setCustomValidity(window.errorMessages.repeatEmail);
                } else {
                    emailConfirmField.setCustomValidity("");
                }
            });
        },
        whenSubmit: function (e) {
            this.formValidated = true;
            this.fields['phone']['mask'] = '';
            let phoneNumber = document.getElementById('fld-register-phone').value;
            if (phoneNumber !== '') {
                this.fields['phone']['value'] = parseInt(phoneNumber.replace(/[^0-9]/g, ''), 10);
            }
        },
        validateCRM: function ()
        {
            this.crmLoading = true;
            CFM.Submit(this.fields.document_professional, this.fields.document_uf)
                .then((status) => {
                    this.crmLoading = false;
                    this.crmIsInvalid = !status;
                    if (!status) {
                        this.crmResponseMessage = 'CRM Inválido ou inativo';
                    }
                })
                .catch((err) => {
                    this.crmLoading = false;
                    this.crmIsInvalid = true;
                    //this.crmIsInvalid = false;
                    this.crmResponseMessage = 'Algo deu errado na requisição';
                })

        },
        readyToContinue: function ()
        {
            return (this.currentSiteName !== 'Brasil' && this.profile !== undefined && this.profile !== null) ||
                (this.currentSiteName === 'Brasil' && this.profile !== 'profissional-da-saude' && this.profile !== null) ||
                (this.currentSiteName === 'Brasil' && this.profile === 'profissional-da-saude' && this.profession !== null && this.profession.slug !== 'medico') ||
                (this.currentSiteName === 'Brasil' && this.profile === 'profissional-da-saude' && (this.profession !== null && this.profession.slug === 'medico') && this.crmIsInvalid === false)
        }
    },
}
